import * as types from '../../actions/actionTypes';
import { changeCurrentCase } from '../cases/actions';
import {
  sendInvitations as sendInviteService,
  getInvitationInfoService,
  acceptInvitation as acceptInvitationService,
  acceptEmployerInvitation as acceptEmployerInvitationService,
} from '../../services/inviteService';

export function sendInvitations(caseId, inviteItems, message, prefill) {
  return function (dispatch, getState) {
    if (!inviteItems) {
      dispatch({
        type: types.INVITES_SEND_FAILURE,
        payload: { message: 'inviteItems is empty' },
      });
      return;
    }

    let inviteObj = {
      caseId: caseId,
      invitees: inviteItems,
      customMessage: message,
      prefill,
    };

    dispatch({
      types: [types.INVITES_SEND_REQUEST, types.INVITES_SEND_SUCCESS, types.INVITES_SEND_FAILURE],
      promise: sendInviteService(inviteObj),
    });
  };
}

export function invitationGuid(guid, authParams = null) {
  return function (dispatch, getState) {
    dispatch({ type: types.INVITE_GUID, payload: { guid } });
  };
}

export function getInvitationInfo(guid = null) {
  return function (dispatch, getState) {
    let pendingInviteGuid = guid || getState().application.pendingInviteGuid;
    if (!pendingInviteGuid) {
      dispatch({
        type: types.INVITES_GET_ACCEPT_FAILURE,
        payload: new Error('no invite guid'),
      });
    }

    dispatch({ type: types.INVITES_GET_ACCEPT_REQUEST });
    getInvitationInfoService(pendingInviteGuid)
      .then((result) => {
        dispatch({ type: types.INVITES_GET_ACCEPT_SUCCESS, payload: result?.data?.data });
        // this must handle if an invite is accepted but the user was already in the case
        if (result.validationError && getState().entities.cases[result.caseId]) {
          dispatch({
            type: types.INVITES_POST_ACCEPT_SUCCESS,
            payload: null,
          });
          dispatch(changeCurrentCase(result.caseId));
        }
        return result;
      })
      .catch((err) => {
        console.info('INVITES_GET_ACCEPT_FAILURE', err);
        dispatch({ type: types.INVITES_GET_ACCEPT_FAILURE, payload: err });
      });
  };
}

// export function setInvitesStateDirty(isDirty) {
//   return function(dispatch, getState) {
//     // If you remove this and use return instead of dispatch should work also.
//     if (isDirty) dispatch({ type: types.INVITES_DIRTY });
//     else dispatch({ type: types.INVITES_CLEAN });
//   };
// }

export function resetState() {
  return function (dispatch) {
    dispatch({ type: types.RESET_INVITES_STATE });
  };
}

export function acceptEmployerInvitation(inviteObj, guid) {
  return {
    types: [
      types.INVITES_POST_ACCEPT_REQUEST,
      types.INVITES_POST_ACCEPT_SUCCESS,
      types.INVITES_POST_ACCEPT_FAILURE,
    ],
    promise: acceptEmployerInvitationService(inviteObj, guid),
  };
}

export function acceptInvitation(inviteObj) {
  return function (dispatch, getState) {
    let guid = inviteObj.guid;
    let caseId = inviteObj.caseId;

    const acceptInvite = {
      userId: getState().user.userId,
      roleId: inviteObj.roleId !== 1 ? inviteObj.roleId : 3,
      champion: inviteObj.roleId === 1,
      guid: guid,
    };
    dispatch({
      types: [
        types.INVITES_POST_ACCEPT_REQUEST,
        types.INVITES_POST_ACCEPT_SUCCESS,
        types.INVITES_POST_ACCEPT_FAILURE,
      ],
      promise: acceptInvitationService(acceptInvite, caseId).then((result) => {
        if (result.validationError && getState().entities.cases[caseId]) {
          dispatch(changeCurrentCase(caseId));
        }
        return {
          ...result,
          caseId,
        };
      }),
    });
  };
}
